const hints = [
  {
    id: 1,
    description: "The more I dry, the wetter I become. What am I?",
    password: "towel",
    // 895207
  },
  {
    id: 2,
    description: "What one word has the most letters in it?",
    password: "mailbox",
    // 412704
  },
  {
    id: 3,
    description:
      "Sitff is my spine and my body is pale, but I'm always ready to tell. What am I?",
    password: "book",
    //133195
  },
  {
    id: 4,
    description:
      "You use a knife to slice my head and weep beside me when I am dead. What am I?",
    password: "onion",
    //256569
  },
  {
    id: 5,
    description: "If you were 'able', you'd add a 'T'",
    password: "table",
    //591962
  },
];

export default hints;
